import React from 'react';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { useHistory } from "react-router";
import { connect } from 'react-redux';
import { SetLoggedIn } from "redux/actions/isLoggedInActions";
import { SetUser } from "redux/actions/userActions";
import { SetOperationSuccess  } from "redux/actions/operationSuccessActions";
import { SetIsRequiredModule } from "redux/actions/isRequiredModuleActions";

const UserDropdown = (props) => {
    const history = useHistory();

    const logout = () => {
        localStorage.removeItem('currentUser-ARS');
        localStorage.removeItem('token-ARS');
        props.SetLoggedIn(false);
        props.SetUser({});
        props.SetOperationSuccess(0);
        props.SetIsRequiredModule(false);
        history.push({
            pathname: "/",
            state: {}
        })
    }

    return (
        <DropdownButton
            alignRight
            title={
                <i className={'fa fa-user'}></i>
              }
            id="dropdown-menu-align-right"
        >
            <Dropdown.Item onClick={logout}>Salir</Dropdown.Item>
        </DropdownButton>
    )
}


const mapDispatchToProps = (dispatch) => {
    return {
      SetUser: (user) => dispatch(SetUser(user)),
      SetLoggedIn: (value) => dispatch(SetLoggedIn(value)),
      SetOperationSuccess: (value) => dispatch(SetOperationSuccess(value)),
      SetIsRequiredModule: (value) => dispatch(SetIsRequiredModule(value)),
    }
  }
  
export default connect(
    null,
    mapDispatchToProps)(UserDropdown);
